
<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import PreViewControlPhoto from "./PreViewControlPhoto.svelte";
    import UploadFile from "./UploadFile.svelte";

    const dispatch = createEventDispatcher();

    export let photoId:string;
    export let contextId:string;


    function addFile(event){
        photoId = event.id;
        dispatch('updatePhoto', photoId);
    }

    function removeFile(){
        dispatch('removePhoto');
    }

</script>

<div class="row">
    {#if photoId}
        <div class="col-12">
            <PreViewControlPhoto photoId={photoId} on:removeFile={(event) => removeFile()} />
        </div>
    {:else}
        <div class="col-12">
            <img class="img-blank" src="/images/blank_perfil.webp" alt="">
        </div>
        <div class="col-4 text-end">
            <UploadFile contextId={contextId} locked={true} on:upload={ (event) => addFile(event.detail) }/>
        </div>
    {/if}
</div>


<style lang="scss">
    .img-blank{
        max-width: 100%;
        margin-bottom: 10px;
    }
</style>




